import React, { useState, useRef, useEffect } from "react";
import { LuEllipsisVertical } from "react-icons/lu";
import { ITransaction } from "../../types";

interface TransactionDropdownActionsProps {
  transaction: ITransaction;
  onView: (transaction: ITransaction) => void;
}

const TransactionDropdownActions = ({
  transaction,
  onView,
}: TransactionDropdownActionsProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const LuEllipsisVerticalIcon = LuEllipsisVertical as React.ElementType;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <LuEllipsisVerticalIcon className="text-gray-600 text-lg" />
      </button>
      {dropdownOpen && (
        <div className="absolute right-0 mt-2 w-24 bg-white shadow-md border rounded-md z-10">
          <button
            className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
            onClick={(e) => {
              e.stopPropagation();
              onView(transaction);
              setDropdownOpen(false);
            }}
          >
            View
          </button>
        </div>
      )}
    </div>
  );
};

export default TransactionDropdownActions;
